// extracted by mini-css-extract-plugin
export var clickThrough = "_yq-2";
export var fallback = "_yq-5";
export var frame = "_yq-3";
export var frameCell = "_yq-1";
export var overlay = "_yq-4";
export var wrapper = "_yq-0";